import { printComanda } from "utils/comanda";
import { numeroPedidoDe } from "./html";

// Comanda remota del evento: la misma venta, por el servicio de impresión, a la
// comandera fija que el backend expone en comanderaDestino. Sigue el patrón de
// "Preparar pedido" (pedidos/index.js) sin compartir código: con comandera fija
// no hay agrupamiento por sección.
//
// Devuelve { resultado, error } y nunca lanza: un fallo remoto no afecta a la
// venta ni a los papeles locales.
export const RESULTADO_COMANDA_REMOTA = Object.freeze({
  EMITIDA: "EMITIDA",
  NO_APLICA: "NO_APLICA",
  ERROR: "ERROR",
});

// El backend decide qué es menú universitario; acá sólo se filtra.
export const lineasComandaRemota = (documentos) =>
  (documentos?.lineas || []).filter((linea) => !linea.esMenuUniversitario);

// Forma que espera printComanda. nroComanda es el mismo número que imprime la
// comanda local: Venta.nroPedido si existe y, si no, el idPedido (el POS no
// completa Venta.nroPedido ni PedidoDetalle.numeroComanda). El print server lo
// exige, y printComanda lo toma de la primera línea. El POS no carga
// comentarios por línea.
export const armarComandaRemota = (documentos) => {
  const nroComanda = numeroPedidoDe(documentos?.pedido) || null;
  return lineasComandaRemota(documentos).map((linea) => ({
    cantidad: linea.cantidad,
    nroComanda,
    producto: { nombre: linea.nombre },
    observaciones: "",
  }));
};

const error = (mensaje) => ({ resultado: RESULTADO_COMANDA_REMOTA.ERROR, error: mensaje });

export const emitirComandaRemota = async (documentos) => {
  const comanda = armarComandaRemota(documentos);
  if (!comanda.length) return { resultado: RESULTADO_COMANDA_REMOTA.NO_APLICA, error: null };

  if (!comanda[0].nroComanda) return error("La venta no tiene número de pedido para la comanda.");

  // Se pasa el objeto Comandera, no el nombre: así printComanda respeta
  // habilitado. Igual se valida antes para que el error sea explícito, ya que
  // printComanda devuelve null en silencio.
  const destino = documentos?.comanderaDestino;
  if (!destino?.printName) return error("No hay comandera de cafetería configurada.");
  if (destino.habilitado === false) return error(`La comandera ${destino.printName} está deshabilitada.`);

  try {
    const respuesta = await printComanda(
      comanda,
      destino,
      documentos?.pedido?.observaciones || null,
      null,
      documentos?.pedido?.vendedor || null,
      // Sin cliente, por consistencia con la comanda local (decisión 21).
      null
    );
    if (respuesta?.status === 200) return { resultado: RESULTADO_COMANDA_REMOTA.EMITIDA, error: null };
    return error("El servidor de impresión no confirmó la comanda.");
  } catch (e) {
    return error(e?.message || "No se pudo enviar la comanda a cafetería.");
  }
};
